import React from 'react';
import './Quality.css';

function Quality() {
  return (
    <div className="quality-page">
      <div className="container">
        <section className="quality-hero">
          <h1>⭐ Premium Quality</h1>
          <p className="subtitle">Authentic Cultural Pieces</p>
        </section>

        <section className="quality-content">
          <p className="intro-text">
            Every item at Heritage Hub is carefully selected for its craftsmanship, authenticity, 
            and cultural significance. We work with trusted makers and vendors who respect tradition 
            while delivering quality that meets modern standards.
          </p>

          <div className="quality-promise">
            <h2>Our quality promise:</h2>
            <ul className="quality-list">
              <li>Authentic South African cultural designs</li>
              <li>Attention to detail in materials and finishing</li>
              <li>Pieces chosen for durability, comfort, and beauty</li>
              <li>Cultural respect at the heart of every product</li>
            </ul>
          </div>

          <section className="quality-commitment">
            <p>
              When you shop with us, you're investing in pieces that honour heritage and are 
              made to be worn, gifted, and cherished.
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Quality;
